module.exports = __webpack_public_path__ + "static/media/smart-work-banner.9e30f8bb.jpg";